/** @jsx h */
import { useState, useRef, useEffect } from 'preact/hooks';
import { labels } from '../../config';
import { Map } from './Map';
import { ConsentOverlay } from '@3pc/consent-overlay';

const MapConsent = ({
  list,
  lat,
  lon,
  isLoading,
  currentPage,
  itemsPerPage,
  searchData,
  inputQuery,
  query,
  pluginNamespace,
  showFacets,
  facets,
  facetsActive,
  sorting,
  triggerAjaxSubmit,
  searchType,
  showMaininput,
  isReset,
  updateUserCoordinates,
  toggleLoadingAnimation,
  coordinatesApi,
  noCoordinatesFound,
  resetFilters,
}) => {
  const refContainer = useRef(null);
  const [consent, setConsent] = useState(false);

  useEffect(() => {
    const container = refContainer.current;
    const overlayInstance = new ConsentOverlay({
      container,
      nameSpace: 'duk',
      onActivation: (container = this.container, consentType) => {
        if (consentType === 'osm') {
          setConsent(true);
        }

        // Focus opt-in
        if (container.contains(document.activeElement)) {
          const content = container.querySelector('.consent-overlay__content');
          content.setAttribute('tabindex', -1);
          content.focus();
        }
      },
      onDeactivation: (container, consentType, consentSubtype) => {
        if (consentType === 'osm') {
          setConsent(false);
        }

        // Focus container
        container.setAttribute('tabindex', -1);
        container.focus();
      },
    });

    overlayInstance.init();
  }, []);

  return (
    <div
      class="consent-overlay consent-overlay--map "
      role="region"
      aria-labelledby="[unique Inhaltselement-ID]"
      data-consent-type="osm"
      ref={refContainer}
    >
      <div class="consent-overlay__opt-in">
        <div class="consent-overlay__description">
          <h3 id="[unique Inhaltselement-ID]" class="consent-overlay__heading">
            {labels.map.consent.heading}
          </h3>
          <p className="consent-overlay__body">{labels.map.consent.text1}</p>
          <p className="consent-overlay__body">{labels.map.consent.text2}</p>
          <div class="consent-overlay__buttons">
            <button
              class="consent-overlay__button styled-button"
              type="button"
              data-accept="once"
            >
              <span class="sr-only"> {labels.map.consent.activateOnce}</span>
              <span class="styled-button__text">
                {labels.map.consent.activateOnce}
              </span>
            </button>
            <button
              class="consent-overlay__button styled-button"
              type="button"
              data-accept="always"
            >
              <span class="sr-only">{labels.map.consent.activateAlways}</span>
              <span class="styled-button__text">
                {labels.map.consent.activateAlways}
              </span>
            </button>
          </div>
        </div>
      </div>
      <div class="consent-overlay__content">
        <Map
          list={list}
          consent={consent}
          lat={lat}
          lon={lon}
          isLoading={isLoading}
          currentPage={currentPage}
          itemsPerPage={itemsPerPage}
          searchData={searchData}
          inputQuery={inputQuery}
          query={query}
          pluginNamespace={pluginNamespace}
          showFacets={showFacets}
          facets={facets}
          facetsActive={facetsActive}
          sorting={sorting}
          triggerAjaxSubmit={triggerAjaxSubmit}
          searchType={searchType}
          showMaininput={showMaininput}
          isReset={isReset}
          updateUserCoordinates={updateUserCoordinates}
          toggleLoadingAnimation={toggleLoadingAnimation}
          coordinatesApi={coordinatesApi}
          noCoordinatesFound={noCoordinatesFound}
          resetFilters={resetFilters}
        />
      </div>
      <div class="consent-overlay__opt-out">
        <div class="consent-overlay__opt-out-inner">
          <button
            class="consent-overlay__button styled-button"
            type="button"
            data-revoke=""
          >
            <span class="sr-only">Externe Inhalte deaktivieren</span>
            <span class="styled-button__text">
              {labels.map.consent.deactivate}
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default MapConsent;
